/**
 * Trolleybus switch
 * - used in Pilsen
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

export default class TbusSwitch extends Element {
  setDefaultShapes () {
    this.shapes = [
      new Ren.Circle({
        name: 'circleAround',
        x: 0,
        y: 0,
        radius: 20,
        opacity: 0.2
      }),
      new Ren.Circle({
        name: 'circleUnder',
        x: 0,
        y: 0,
        radius: 20,
        opacity: 1,
        strokeEnabled: false,
        fill: Color.white
      }),
      new Ren.Circle({
        name: 'offline',
        x: 0,
        y: 0,
        radius: 20,
        opacity: 0.3,
        strokeEnabled: false,
        fill: Color.offlineGray
      }),
      new Ren.Circle({
        name: 'onlineStatus',
        x: -10,
        y: -20,
        radius: 3,
        opacity: 1,
        fill: 'red'
      })
    ]

    if (this.elementTypeName === 'TbusSwitchLeft') {
      // default
      this.shapes.push(
        new Ren.Line({
          points: [0, 20, 0, 0],
          lineCap: 'round'
        }),
        new Ren.Line({
          name: 'left',
          points: [0, 0, -20, -20],
          lineCap: 'round',
          visible: true
        }),
        new Ren.Line({
          name: 'right',
          points: [0, 0, 0, -20],
          lineCap: 'round',
          visible: true
        })
      )
    } else if (this.elementTypeName === 'TbusSwitchRight') {
      // default
      this.shapes.push(
        new Ren.Line({
          points: [0, 20, 0, 0],
          lineCap: 'round'
        }),
        new Ren.Line({
          name: 'left',
          points: [0, 0, 0, -20],
          lineCap: 'round',
          visible: true
        }),
        new Ren.Line({
          name: 'right',
          points: [0, 0, 20, -20],
          lineCap: 'round',
          visible: true
        })
      )
    }
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(newVariables)
    // online
    if (this.online) {
      this.modifyShape('offline', 'visible', false)
    }

    // variable: position
    if (status.position === 1) {
      this.modifyShape('left', 'visible', false)
      this.modifyShape('right', 'visible', false)
    } else if (status.position === 0) {
      this.modifyShape('left', 'visible', true)
      this.modifyShape('right', 'visible', false)
    } else if (status.position === 2) {
      this.modifyShape('left', 'visible', false)
      this.modifyShape('right', 'visible', true)
    }
  }
}
